import {
	IAcountData,
	IdataContributionAccount,
	IdataDepositAccount,
	IdataDepositAccountStorage,
	IdataLoantAccount,
	IDataSelectAccount,
	IDataTermDeposit,
	IYear
} from '@pacifico/interfaces/components.interface';
import { IListParameter } from '@pacifico/interfaces/generic-api.interface';
import {
	Detail,
	IAcountDataStorage,
	IAcountDataTable,
	IBalancesAccount,
	IDetail,
	IDetailTableLends,
	IDetailTableMovement,
	IListAccountsOrigin,
	IResListTermDeposistsTransaction
} from '@pacifico/interfaces/inquiries-api.interface';
import { CURRENCY_SYMBOL, FIX_TERM_DEPLATYPE } from './enums';

export class Util {
	static REGEX_PASSWORD = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[&#.,;])[0-9a-zA-Z&#.,;]{8,}$/gm;

	static isNegative(value: string): boolean {
		const number = Number(this.replaceCommaNumber(value.toString()));
		return number < 0;
	}

	static isNumber(value: string): boolean {
		return /^-?[\d.]+(?:e-?\d+)?$/.test(value);
	}

	static castResponseAccount(response: IListAccountsOrigin): IDataSelectAccount {
		const dataSelect: IDataSelectAccount = {
			id: response.accountNumber,
			title: `${response.accountNumber}`,
			subTitle: Util.remove_accents(response.accountDescription),
			availableBalanceText: `${response.symbolCoin}${response.availableBalance}`,
			availableBalance: this.replaceCommaNumber(response.availableBalance),
			codeCurrency: response.codeCoin === 1 ? 'PEN' : 'USD',
			symbolCoin: response.symbolCoin,
			codeCoin: response.codeCoin,
			textCoin: this.getTextCurrency(response.codeCoin),
			serviceTable: response.serviceTable,
			serviceArgument: response.serviceArgument
		};
		return dataSelect;
	}

	/**
	 * Tener en cuenta que esta funcion se utiliza con la respuesta que retorna el servicio de  "inquiries/accounts"; se crea esto para poder obtener las cuentas CTS ya que el servicio "/inquiries/listaccounts" no retorna las cuentas CTS. 14-12-2021
	 *
	 * @param response
	 * @returns
	 */
	static getCtsAccounts(response: IBalancesAccount[]): IDataSelectAccount[] | undefined {
		const accountsCts = response.filter((item) => item.codeProduct === '1051');
		if (accountsCts.length > 0) {
			const listAccount: IDataSelectAccount[] = [];

			accountsCts.forEach((item) => {
				item.listAccount.forEach((account) => {
					const dataSelect: IDataSelectAccount = {
						id: account.accountNumber!,
						title: `${account.accountNumber!}`,
						subTitle: account.accountDescription!,
						availableBalanceText: `${account.symbolCoin!}${account.availableBalance!}`,
						availableBalance: this.replaceCommaNumber(account.availableBalance!),
						codeCurrency: account.codeCoin === 1 ? 'PEN' : 'USD',
						symbolCoin: account.symbolCoin,
						codeCoin: account.codeCoin,
						textCoin: this.getTextCurrency(account.codeCoin!),
						serviceTable: account.serviceTable,
						serviceArgument: account.serviceArgument,
						amountIntangible: this.replaceCommaNumber(account.amountIntangible!)
					};

					listAccount.push(dataSelect);
				});
			});

			return listAccount;
		}

		return undefined;
	}

	static remove_accents(_strAccents: string): string {
		const strAccents = _strAccents.split('');
		const strAccentsOut: string[] = [];
		const strAccentsLen = strAccents.length;
		const accents = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž�';
		const accentsOut = 'AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZzó';
		for (let y = 0; y < strAccentsLen; y++) {
			if (accents.indexOf(strAccents[y]) != -1) {
				strAccentsOut[y] = accentsOut.substr(accents.indexOf(strAccents[y]), 1);
			} else strAccentsOut[y] = strAccents[y];
		}
		return String(strAccentsOut.join(''));
	}

	/**
	 *Función para reemplazar las comas de un número en texto
	 * @param value numero en texto, por ejemplo '12,358.28'
	 * @returns el valor convertido a numero
	 */
	static replaceCommaNumber(value: string): number {
		return Number(value.replace(/,/g, ''));
	}

	/**
	 *Función para reemplazar los guiones de un número en texto
	 * @param value numero en texto, por ejemplo '12-358.28'
	 * @returns el valor convertido a numero
	 */
	static replaceHyphenNumber(value: string): number {
		return Number(value.replace(/-/g, ''));
	}
	/**
	 *Función que retorna el texto de la moneda, si es 1 es 'Soles' de lo contrario sera 'Dolar'
	 * @param codeCoin id del tipo de moneda
	 * @returns el texto de la moneda
	 */
	static getTextCurrency(codeCoin: number): string {
		return codeCoin === 1 ? 'Soles' : 'Dólares';
	}
	/**
	 * Función que retorna el texto de la moneda y símbolo, si es 1 es '(S/) Soles' sino '($) Dólares'
	 * @param codeCoin id del tipo de moneda
	 * @returns texto de moneda y símbolo
	 */
	static transformCurrency(codeCoin: number): string {
		return codeCoin === 1 ? '(S/) Soles' : '($) Dólares';
	}

	static getSymbolCurrency(codeCoin: number): string {
		return codeCoin === 1 ? CURRENCY_SYMBOL.SOLES : CURRENCY_SYMBOL.DOLARES;
	}

	static castToDataTable(item: IAcountDataStorage): IAcountData {
		const dataSelect: IAcountData = {
			nrCuenta: item.nrCuenta!,
			moneda: item.symbolMoney!,
			aliasCuenta: item.aliasCuenta!,
			saldoDisponible: item.saldoDisponible!,
			saldoContable: item.saldoContable!,
			numeroTarjeta: item.numeroTarjeta!
		};
		return dataSelect;
	}

	static castToDataTableDeposit(item: IAcountDataStorage): IdataDepositAccount {
		const dataSelect: IdataDepositAccount = {
			nrCuenta: item.nrCuenta!,
			moneda: item.symbolMoney!,
			aliasCuenta: item.aliasCuenta!,
			importeApertura: item.importeApertura!,
			saldoFecha: item.saldoFecha!,
			interesDisponible: item.interesDisponible!,
			proximaRenovacion: item.proximaRenovacion!,
			enGarantia: item.enGarantia!,
			numeroTarjeta: item.numeroTarjeta!
		};
		return dataSelect;
	}

	static castToDataTableTermDeposit(item: IdataDepositAccountStorage): IdataDepositAccount {
		const dataSelect: IdataDepositAccount = {
			nrCuenta: item.nrCuenta,
			moneda: item.moneda,
			aliasCuenta: item.aliasCuenta,
			importeApertura: item.importeApertura,
			saldoFecha: item.saldoFecha,
			interesDisponible: item.interesDisponible,
			proximaRenovacion: item.proximaRenovacion,
			enGarantia: item.enGarantia,
			giftCommission: item.giftCommission
		};
		return dataSelect;
	}

	static castToDataTableLoans(item: IAcountDataStorage): IdataLoantAccount {
		const dataSelect: IdataLoantAccount = {
			periodo: item.periodo!,
			nroSolicitud: item.nroSolicitud!,
			moneda: item.symbolMoney!,
			alias: item.aliasCuenta!,
			montoPrestamo: item.montoPrestamo!,
			pagoTotal: item.pagoTotal!,
			diaPago: item.diaPago!
		};
		return dataSelect;
	}

	static castToDataTableContributions(item: IAcountDataStorage): IdataContributionAccount {
		const dataSelect: IdataContributionAccount = {
			nrCuenta: item.nrCuenta?.toString() || '*',
			moneda: item.symbolMoney!,
			alias: item.aliasCuenta!,
			aporte: item.aportesAcumulados!,
			aportePendiente: item.aportesPendientes!,
			nroAporte: item.nroAportesPendientes!.toString()
		};
		return dataSelect;
	}

	static castDetail2DetailTableLends(detail: Detail[]): IDetailTableLends[] {
		const detailTableLend: IDetailTableLends[] = [];
		detail.forEach((item) => {
			const det: IDetailTableLends = {
				date: item.date.replace(/\//g, '-'),
				type: item.type,
				amount: item.amortization,
				rate: item.rate,
				moratoriumRate: item.moratoriumRate,
				readjustment: item.readjustment,
				insurance: item.insurance,
				contributions: item.contributions,
				balance: item.balance
			};
			detailTableLend.push(det);
		});
		return detailTableLend;
	}

	static castIDetail2DetailTableMovements(detail: IDetail[]): IDetailTableMovement[] {
		const detailTableMovement: IDetailTableMovement[] = [];
		detail.forEach((item) => {
			const det: IDetailTableMovement = {
				date: item.date.replace(/\//g, '-'),
				idMovement: item.idMovement,
				agencyDescription: item.agencyDescription === '' ? '-' : item.agencyDescription,
				description: item.description,
				amount: item.amount
			};
			detailTableMovement.push(det);
		});
		return detailTableMovement;
	}

	static castResponseAccountResume(response: IBalancesAccount): IAcountDataTable {
		let dataTable;
		if (this.isSaveAccount(response.codeProduct)) {
			const currencyType: string[] = [];
			const datatableSaveCTS: IAcountDataTable = {
				codeProduct: response.codeProduct,
				title: response.descriptionProduct,
				listAccounts: []
			};
			response.listAccount.forEach((item) => {
				const account: IAcountDataStorage = {
					nrCuenta: item.accountNumber?.toString() || '',
					moneda: item.codeCoin,
					aliasCuenta: item.accountAlias,
					saldoDisponible: item.availableBalance || '',
					saldoContable: item.countableBalance || '',
					numeroTarjeta: item.cardNumber,
					saldoIntangible: item.amountIntangible || '',
					monedaText: item.codeCoin === 1 ? 'SOLES' : 'DÓLARES',
					symbolMoney: item.descriptionCoin,
					currencyIntangible: item.descriptionCoinIntangible || '',
					importeApertura: item.beganAmount || '0.00',
					symbolMoney2: item.symbolCoin,
					interesDisponible: item.availableRate || '0.00',
					fechaInicio: item.beganDate || '',
					fechaFin: item.endDate || '',
					savingGoal: item.savingGoal || '',
					nroCuota: item.quotaNumber?.toString() || '',
					aportesAcumulados: item.numberQuotasPaid?.toString() || '',
					treaOtea: item.rateTrea || '',
					ahorroProgramado: String(item.quotaAmount) || '',
					fechaApertura: new Date(item.beganDate?.split('/').reverse().toString() || ''),
					fechaVencimiento: new Date(item.endDate?.split('/').reverse().toString() || ''),
					numeroQuota: item.quotaNumber || 0,
					numeroQuotasPagadas: item.numberQuotasPaid || 0,
					montoQuota: item.quotaAmount || 0,
					tea: String(item.rate) || '',
					saldoAlaFecha: String(Number(item.availableBalance) + Number(item.availableRate)),
					personDataList: item.personalDataList || []
				};
				datatableSaveCTS.listAccounts.push(account);
				currencyType.push(account.moneda?.toString() || '');
			});
			if (currencyType.includes('1')) {
				datatableSaveCTS.subtotalSoles = [
					response.totalAmount?.available?.totalPEN || '',
					response.totalAmount?.countable?.totalPEN || ''
				];
			}
			if (currencyType.includes('2')) {
				datatableSaveCTS.subtotalDolares = [
					response.totalAmount?.available?.totalUSD || '',
					response.totalAmount?.countable?.totalUSD || ''
				];
			}
			dataTable = datatableSaveCTS;
		} else if (this.isFixDepositAccount(response.codeProduct)) {
			const currencyType: string[] = [];
			const datatableFixDeposit: IAcountDataTable = {
				codeProduct: response.codeProduct,
				title: response.descriptionProduct,
				listAccounts: []
			};
			response.listAccount.forEach((item) => {
				const account: IAcountDataStorage = {
					nrCuenta: item.numberAccount?.toString(),
					moneda: item.money,
					aliasCuenta: item.alias,
					importeApertura: item.beganAmount,
					saldoFecha: item.countable,
					interesDisponible: item.availableRate || '',
					proximaRenovacion: item.expireDate?.replace(/\//g, '-') || '',
					enGarantia: item.guanrantee,
					monedaText: item.money === 1 ? 'SOLES' : 'DÓLARES',
					saldoDisponible: item.available || '',
					fechaApertura: new Date(item.openingDate?.split('/').reverse().toString() || ''),
					fechaVencimiento: new Date(item.expireDate?.split('/').reverse().toString() || ''),
					treaOtea: item.trea || '',
					numDias: item.dayNumber,
					numDiasText: `${item.dayNumber || '**'} días`,
					symbolMoney: item.descriptionMoney
				};
				datatableFixDeposit.listAccounts.push(account);
				currencyType.push(account.moneda?.toString() || '');
			});
			if (currencyType.includes('1')) {
				datatableFixDeposit.subtotalSoles = [
					response.totalAmount?.initialAmount?.totalPEN || '',
					response.totalAmount?.currentBalance?.totalPEN || '',
					response.totalAmount?.interestRate?.totalPEN || ''
				];
			}
			if (currencyType.includes('2')) {
				datatableFixDeposit.subtotalDolares = [
					response.totalAmount?.initialAmount?.totalUSD || '',
					response.totalAmount?.currentBalance?.totalUSD || '',
					response.totalAmount?.interestRate?.totalUSD || ''
				];
			}
			dataTable = datatableFixDeposit;
		} else if (this.isLoansAccount(response.codeProduct)) {
			const currencyType: string[] = [];
			const datatableLoans: IAcountDataTable = {
				codeProduct: response.codeProduct,
				title: response.descriptionProduct,
				listAccounts: []
			};
			response.listAccount.forEach((item) => {
				const account: IAcountDataStorage = {
					nrCuenta: item.loan || '',
					periodo: item.requestPeriod?.toString() || '',
					nroSolicitud: item.requestNumber?.toString() || '',
					moneda: item.money,
					aliasCuenta: item.product,
					montoPrestamo: item.loanAmount || '',
					pagoTotal: item.loanBalance || '',
					diaPago: item.payDay?.toString() || '',
					monedaText: item.money === 1 ? 'SOLES' : 'DÓLARES',
					deudaVigente: item.totalAmount,
					nroCuota: `${item.quotaPaid?.toString() || '*'}/${item.quotaNumber?.toString() || '*'}`,
					tem: item.tem,
					tea: item.tea,
					symbolMoney: item.moneyDescription,
					fechaOtorgamiento: new Date(item.loadDate?.split('/').reverse().toString() || '') || ''
				};
				datatableLoans.listAccounts.push(account);
				currencyType.push(account.moneda?.toString() || '');
			});
			if (currencyType.includes('1')) {
				datatableLoans.subtotalSoles = [
					response.totalAmount?.loanAmount?.mountPEN || '',
					response.totalAmount?.totalPayment?.mountPEN || ''
				];
			}
			if (currencyType.includes('2')) {
				datatableLoans.subtotalDolares = [
					response.totalAmount?.loanAmount?.mountUSD || '',
					response.totalAmount?.totalPayment?.mountUSD || ''
				];
			}
			dataTable = datatableLoans;
		} else if (this.isContributionAccount(response.codeProduct)) {
			const currencyType: string[] = [];
			const datatableContribution: IAcountDataTable = {
				codeProduct: response.codeProduct,
				title: response.descriptionProduct,
				listAccounts: []
			};
			response.listAccount.forEach((item) => {
				const account: IAcountDataStorage = {
					nrCuenta: item.accountNumber?.toString() || '',
					aliasCuenta: item.alias,
					moneda: item.money,
					aportesAcumulados: item.balance,
					aportesPendientes: item.pendingDebt,
					nroAportesPendientes: item.pendingQuotas,
					monedaText: item.money === 1 ? 'SOLES' : 'DÓLARES',
					symbolMoney: item.descriptionMoney
				};
				datatableContribution.listAccounts.push(account);
				currencyType.push(account.moneda?.toString() || '');
			});
			if (currencyType.includes('1')) {
				datatableContribution.subtotalSoles = [
					response.totalAmount?.currentContribution?.mountPEN || '',
					response.totalAmount?.pendingContribution?.mountPEN || ''
				];
			}
			if (currencyType.includes('2')) {
				datatableContribution.subtotalDolares = [
					response.totalAmount?.currentContribution?.mountUSD || '',
					response.totalAmount?.pendingContribution?.mountUSD || ''
				];
			}
			dataTable = datatableContribution;
		}
		// eslint-disable-next-line @typescript-eslint/no-unsafe-return
		return dataTable;
	}

	static isSaveAccount(codeProduct: string): boolean {
		return (
			codeProduct === '1011' ||
			codeProduct === '1013' ||
			codeProduct === '1014' ||
			codeProduct === '1021' ||
			codeProduct === '1051' ||
			codeProduct === '1041' ||
			codeProduct === '1023' ||
			codeProduct === '1024'
		);
	}

	static isFixDepositAccount(codeProduct: string): boolean {
		return codeProduct === '2011' || codeProduct === '2013' || codeProduct === '2014';
	}

	static isLoansAccount(codeProduct: string): boolean {
		return codeProduct === '3011';
	}

	static isContributionAccount(codeProduct: string): boolean {
		return codeProduct === '4011';
	}

	static generateYears(initial: number): IYear[] {
		const SelectedAux: IYear[] = [];
		const dif = 1; /* numero de años inferiores al argumento inicial */
		const year = initial - dif;
		for (let i = 0; i <= dif; i++) {
			const item: IYear = {
				id: (year + i).toString(),
				value: (year + i).toString()
			};
			SelectedAux.push(item);
		}
		return SelectedAux;
	}
	/**
	 *  Esta función retorna la lista de documentos de identidad, los "id" corresponden a las especificaciones dadas por el cliente.
	 * @returns Lista de documentos de identindad
	 */
	static getIdentityDocuments(): IIdentityDocument[] {
		return [
			{
				id: 1,
				description: 'DNI',
				longitud: 8,
				isExact: true
			},
			{
				id: 4,
				description: 'C.E',
				longitud: 12,
				isExact: false
			},
			{
				id: 14,
				description: 'RUC',
				longitud: 11,
				isExact: true
			}
		];
	}

	/**
	 * Esta función retorna el documento de identidad
	 *
	 * @param id id del tipo de documento de identidad
	 * @returns el documento de identidad
	 */
	static getIdentityDocument(id: number): IIdentityDocument {
		return this.getIdentityDocuments().find((item) => item.id === id)!;
	}

	static getMessageOfTransferHours(params: IListParameter[]): string {
		const processTime = params.find((item) => item.key === 'processingTimeAfterHours');
		const daysOfAttention = params.find((item) => item.key === 'daysOfAttention01');
		const scheduleOfAttention = params.find((item) => item.key === 'scheduleOfAttention01');
		const daysOfAttentionSaturday = params.find((item) => item.key === 'scheduleOfAttention02');

		return `Transferencia hacia bancos dentro de los ${
			processTime ? processTime.parameter : '60 min'
		} de recibida la orden, en caso de feriados o fuera del horario de atención al día siguiente útil.<br />Horario ${
			daysOfAttention ? daysOfAttention.parameter : 'L-V'
		} : ${scheduleOfAttention ? scheduleOfAttention.parameter : '9:00 am – 6:00 pm'}, Sáb ${
			daysOfAttentionSaturday ? daysOfAttentionSaturday.parameter : '9:30 am – 12:30 pm'
		}`;
	}

	static castResponse2TermDedosit(response: IResListTermDeposistsTransaction[]): IDataTermDeposit[] {
		const datatableDepostiFix: IDataTermDeposit = {
			title: FIX_TERM_DEPLATYPE.INDIVIDUAL,
			listAccounts: []
		};
		const datatableDepostiFixInd: IDataTermDeposit = {
			title: FIX_TERM_DEPLATYPE.INDISTINTO,
			listAccounts: []
		};
		const datatableDepostiFixConj: IDataTermDeposit = {
			title: FIX_TERM_DEPLATYPE.CONJUNTO,
			listAccounts: []
		};
		response.forEach((item) => {
			if (this.isDepositFixIndividual(item.deplaType)) {
				const account: IdataDepositAccountStorage = {
					nrCuenta: item.numberAccount?.toString() || '',
					moneda: item.descriptionMoney,
					aliasCuenta: item.alias,
					importeApertura: item.beganAmount,
					saldoFecha: item.countable,
					interesDisponible: item.availableRate,
					proximaRenovacion: item.expireDate?.replace(/\//g, '-') || '',
					enGarantia: item.guanrantee,
					interesGanado: item.interestWin,
					balanceDisponible: item.available,
					giftCommission: item.termDepositsCancelDTO.giftCommission
				};
				datatableDepostiFix.listAccounts.push({
					accountDataTable: account,
					accountTermDepositCancel: item.termDepositsCancelDTO
				});
			} else if (this.isDepositFixMancInds(item.deplaType)) {
				const account: IdataDepositAccountStorage = {
					nrCuenta: item.numberAccount?.toString() || '',
					moneda: item.descriptionMoney,
					aliasCuenta: item.alias,
					importeApertura: item.beganAmount,
					saldoFecha: item.countable,
					interesDisponible: item.availableRate,
					proximaRenovacion: item.expireDate?.replace(/\//g, '-') || '',
					enGarantia: item.guanrantee,
					interesGanado: item.interestWin,
					balanceDisponible: item.available
				};
				datatableDepostiFixInd.listAccounts.push({
					accountDataTable: account,
					accountTermDepositCancel: item.termDepositsCancelDTO
				});
			} else if (this.isDepositfixMancConjunto(item.deplaType)) {
				const account: IdataDepositAccountStorage = {
					nrCuenta: item.numberAccount?.toString() || '',
					moneda: item.descriptionMoney,
					aliasCuenta: item.alias,
					importeApertura: item.beganAmount,
					saldoFecha: item.countable,
					interesDisponible: item.availableRate,
					proximaRenovacion: item.expireDate?.replace(/\//g, '-') || '',
					enGarantia: item.guanrantee,
					interesGanado: item.interestWin,
					balanceDisponible: item.available
				};
				datatableDepostiFixConj.listAccounts.push({
					accountDataTable: account,
					accountTermDepositCancel: item.termDepositsCancelDTO
				});
			}
		});

		return [datatableDepostiFix, datatableDepostiFixInd, datatableDepostiFixConj];
	}

	static isDepositFixIndividual(deplaType: string): boolean {
		return deplaType === FIX_TERM_DEPLATYPE.INDIVIDUAL;
	}

	static isDepositFixMancInds(deplaType: string): boolean {
		return deplaType === FIX_TERM_DEPLATYPE.INDISTINTO;
	}

	static isDepositfixMancConjunto(deplaType: string): boolean {
		return deplaType === FIX_TERM_DEPLATYPE.CONJUNTO;
	}

	/**
	 *Es ta función retorna el tipo de moneda, teniendo en cuenta la estructura de una cuenta pacifico :
   codigo socio - moneda - tipo de cuenta - numerocorrelativo

   numerocorrelativo: siempre sera 3 digitos
   tipo de cuenta : siempre sera 1 digito, los valores son 1) aportaciones  2) ahorro 3) plazo fijo
   moneda: siempre sera 1 digito, los valores son 1) soles 2) dolares

   el resto es el código del socio
   *
	 * @param account
	 * @returns
	 */
	static getTypeMoney(account: string): string {
		const typeMoney = account.substr(account.length - 5).substring(0, 1);
		return typeMoney;
	}

	static calculateAge(birth: Date): number {
		const timeDiff = Date.now() - birth.getTime();
		// 365.25 - tomando en cuenta anio bisiesto
		return Math.floor(timeDiff / (1000 * 3600 * 24) / 365.25);
	}

	static convertStringToDateDDMMYYYY(date: string): Date | null {
		let value: Date | null = null;

		try {
			if (date) {
				const arrayDate = date.split('/');

				if (arrayDate && arrayDate.length >= 3) {
					const year = Number(arrayDate[2]);
					const month = Number(arrayDate[1]) - 1;
					const day = Number(arrayDate[0]);
					value = new Date(year, month, day, 0, 0);
				}
			}
		} catch (e) {
			console.log(e);
		}

		return value;
	}
}

export interface IIdentityDocument {
	id: number;
	description: string;
	longitud: number;
	isExact: boolean;
}
